/** The couple of things the studio remembers for the length of a visit.
 *
 *  Which filter was on, what was typed in the search and how far down the list
 *  was scrolled: coming back
 *  from a lead should land where you left, the way a list does in a real app
 *  rather than at the top the way a page does.
 *
 *  They live here, on their own, because the shell drawn at launch has to know
 *  the filter before the list that owns it has been downloaded, and a key
 *  written out as a string in two files is a key that will disagree with
 *  itself one day. Every read and write is wrapped: in private browsing the
 *  whole of sessionStorage throws on touch. */

export const LAST_FILTER = "minime.filter";
export const LAST_SEARCH = "minime.search";
export const LAST_SCROLL = "minime.scroll";
export const LAST_RANGE = "minime.range";
/** Which of the search and AI page's tabs was open, so the way back to it, or
 *  the shell drawn at launch, opens on the same one. The URL's ?tab wins when
 *  there is one: a link to a tab is a link to that tab. */
export const LAST_SEO_TAB = "minime.seoTab";
/** Which of the Ask page's conversations is open, so a tap through to a lead
 *  and back, or a reload, lands in it again. Only the id: the conversation
 *  itself is kept in Firestore (askChats), where the list of past ones is. */
export const LAST_ASK = "minime.ask";

export function recall(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function remember(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* private browsing */
  }
}
